module.exports = __webpack_public_path__ + "static/media/left.6dfe1837.svg";